import { Presence } from 'lib-shared-legacy-types';

import { isAgentAvailableOnPhoneChannel } from './isAgentAvailableOnThePhone';
import { isAgentOnThePhone } from './isAgentOnThePhone';

/**
 * Checks whether it's possible to call an agent.
 *
 * @param presence Presence object
 * @returns Boolean
 */
export function isAgentAvailableForCall(presence: Presence): boolean {
  return (
    !isAgentOnThePhone(presence) && isAgentAvailableOnPhoneChannel(presence)
  );
}
